import classes from './Sidebar.module.css';
import SideBarItem from './SidebarItem/SidebarItem';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import MenuIcon from '../../../UI/icons/MenuIcon/MenuIcon';
import ArrowLeftIcon from '../../../UI/icons/ArrowLeftIcon/ArrowLeftIcon';
// import OrderIcon from '../../UI/icons/OrderIcon/OrderIcon';
import ProductIcon from '../../../UI/icons/ProductIcon/ProductIcon';
import CategoryIcon from '../../../UI/icons/CategoryIcon/CategoryIcon';
import AccountIcon from '../../../UI/icons/AccountIcon/AccountIcon';
import { PATHS } from '../../../../constants/routes';
import OrderIcon from '../../../UI/icons/OrderIcon/OrderIcon';

const Sidebar: React.FC = () => {
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (location.pathname === '/admin') {
            setIsOpen(true);
        } else {
            setIsOpen(false);
        }
    }, [location.pathname]);

    const sidebarHandler = () => {
        setIsOpen((prevState) => !prevState);
    };

    return (
        <div className={`${classes.sidebar} ${isOpen && classes.open}`}>
            <button className={`${classes['toggle-btn']} ${isOpen && classes.opened}`} onClick={sidebarHandler}>
                {isOpen ? <ArrowLeftIcon /> : <MenuIcon />}
            </button>

            <nav className={classes.navigation}>
                <ul className={`${isOpen && classes['list-opened']} ${classes.list}`}>
                    <SideBarItem isOpen={isOpen} title={'Заказы'} icon={<OrderIcon />} link={PATHS.orders} />
                    <SideBarItem isOpen={isOpen} title={'Товары'} icon={<ProductIcon />} link={PATHS.products} />
                    <SideBarItem isOpen={isOpen} title={'Пользователи'} icon={<AccountIcon width={30} height={30} />} link={PATHS.users} />
                    <SideBarItem isOpen={isOpen} title={'Настройки'} icon={<CategoryIcon />} link={PATHS.settings} />
                    <SideBarItem isOpen={isOpen} title={'Обратная связь'} iconLink={'/icons/mobile/mail_w.svg'} link={PATHS.feedback} />
                    <SideBarItem isOpen={isOpen} title={'Честный знак'} iconLink={'/icons/logo-crpt.png'} link={PATHS.crpt} />
                </ul>
            </nav>
        </div>
    );
};

export default Sidebar;
